
















































import VisitDeleteConfirm from './widgets/VisitDeleteConfirm.vue';
import SendDialog from './widgets/SendDialog.vue';
import SendDialogRelation from './widgets/SendDialogRelation.vue';
import deleteConfirm from './widgets/deleteConfirm.vue';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
  components: {
    VisitDeleteConfirm,
    SendDialog,
    SendDialogRelation,
    deleteConfirm,
  },
  props: {
    extra: {
      type: Object,
      default: () => ({}),
    },
    dialogName: {
      type: String,
      default: '',
    },
    showMask: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onClickClose = () => {
      emit('click-close');
    };

    const onClickConfirm = (data) => {
      emit('click-confirm', data);
    };

    return {
      onClickClose,
      onClickConfirm,
    };
  },
});
